import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getSignature = 'signature';
const postSignatureUrl = 'signature';
const putSignature = 'signature/';
const deleteSignature = 'signature/';

class SignatureService {
    getSignature(currentPage,pageSize,searchSignature) {
        return axios.get(
            API_URL + getSignature,
            {
                params : {
                    pageNo : currentPage,
                    pageSize : pageSize,
                    filter : searchSignature
                },
                headers: authHeader()
            });
    }

    postSignature(formData) {
        var headers = authHeader();
        var form = new FormData();

        form.append("nama", formData.nama);
        form.append("jabatan", formData.jabatan);
        if (typeof formData.signature !== 'undefined') {
            form.append('signature', formData.signature);
        }
        form.append("status", formData.status);
        return axios
            .post(API_URL + postSignatureUrl, form, {
                headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() }
            })
            .then(response => {

                return response.data.message;
            });
    }

    putSignature(formData) {
        var form = new FormData();        

        form.append("nama", formData.nama);
        form.append("jabatan", formData.jabatan);
        form.append("idSignature", formData.idSignature);

        if (typeof formData.signature !== 'undefined') {
            form.append('signature', formData.signature);
        }

        form.append("status", formData.status);
        return axios
            .put(
                API_URL + putSignature + formData.idSignature,
                form,
                { headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() } }
            );
    }

    deleteSignature(formData) {        

        return axios
            .delete(
                API_URL + deleteSignature + formData.idSignature,
                { headers: authHeader() }
            );
    }

}

export default new SignatureService();